module.exports = __webpack_public_path__ + "static/Fire-red-pesto-952ee93d2f7efc74c46f4de5d5dc49a2.png";